module.exports = __webpack_public_path__ + "img/coupons.c1d6a047.png";